export function lockoutsViewed(workspaceId, user) {
  window.analytics.track('Viewed lockout', {
    workspace_id: workspaceId,
    user_id: user.id,
    user_email: user.email
  })
}
